/**
 * Uncomment this only if you have js functionality for the component
 * 
 */

var chatBotAnimationDelay = 900;

jQuery(document).on('ready', function () {
    
    // Check if component is added to the page
    if( jQuery('section.estimates').length ) {

        // Hide footer
        jQuery('footer').hide();

        // Custom checkboxes
        jQuery('<div class="cos-radio"></div>').insertAfter('.estimates.estimates-form input[type=radio]');
        jQuery('.cos-radio').parent().addClass('cos-radio-loaded');

        // Activate/deactivate chat-bot button
        jQuery('.estimates.estimates-form').on('focusout keyup', '.form input', function() {
            checkField(jQuery(this));
            // Activate
            if(checkForm('.estimates.estimates-form', true) == 0) {
                jQuery('.estimates.estimates-form .jump-next-section.special.bottom').removeClass('deactivated');
                jQuery('.section.section-chat-bot').show();
                startChatBotConversation();
                jQuery('section.estimates-form .jump-next-section.tooltip').tooltipster('show');
            }
            // Deactivate
            else {
                jQuery('.estimates.estimates-form .jump-next-section.special.bottom').addClass('deactivated');
                jQuery('.section.section-chat-bot').hide();
                jQuery('section.estimates-form .jump-next-section.tooltip').tooltipster('hide');
            }
        });

        // Show/hide chat-bot
        jQuery('section').on('click', '.estimates.estimates-form .jump-next-section.special.bottom', function() {
            jQuery(this).tooltipster('hide');
            if(checkForm('.estimates.estimates-form') == 0) {
                jQuery('.estimates.estimates-form .jump-next-section.special.bottom').removeClass('deactivated');
                jQuery('.section.section-chat-bot').show();
                scrollToElement('section.section-chat-bot');
                startChatBotConversation();
                jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').trigger('focus');
            } else {
                jQuery('.estimates.estimates-form .jump-next-section.special.bottom').addClass('deactivated');
                jQuery('.section.section-chat-bot').hide();
                scrollToElement('section.estimates .field-error', false, -10);
            }
        });

        // Chat-bot
        jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').on("keyup", function(e) {
            if (e.key === 'Enter') {
                answerToChatBot();
            }
        });

        // Chat-bot skip question
        jQuery('.chatbot-skip-question').on("click", function() {
            answerToChatBot(true);
        });

        // Submit form
        jQuery('.submit-form').not('.loading').on('click', function() {
            // Prepare UTM
            var utmSource = getUrlParameter('utm_source');
            var utmMedium = getUrlParameter('utm_medium');
            var utmCampaign = getUrlParameter('utm_campaign');
            var utmJson = encodeURIComponent(JSON.stringify({ 'utm_source': utmSource, 'utm_medium': utmMedium, 'utm_campaign': utmCampaign }));
            // Save UTM CF7 content
            jQuery('.estimates.estimates-form textarea[name=utm]').val(utmJson);
            // Submit
            jQuery(this).addClass('loading');
            jQuery('.estimates.estimates-form form input[type=submit]').trigger('click');
        });

        // Show success step
        var wpcf7Elm = document.querySelector( '.estimates.estimates-form' );
        wpcf7Elm.addEventListener( 'wpcf7mailsent', function() {
            // Hide all tooltips
            jQuery('.tooltip').tooltipster('hide');
            jQuery('.components > section').not('.section-success').hide();
            jQuery('section.section-success').show();
            setTimeout(function() {
                window.location.replace(jQuery('.section-success .button').data('redirect-url'));
            }, 10000);
        }, false );
    }
    
});


// Chat-bot - Answer to chat-bot
function answerToChatBot(skipQuestion=false) {
    var chatAnswer = jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').val();
    var currentQuestionNo = jQuery('.estimates.estimates-chat-bot .chat-bot').data('question-no');
    var chatBotCF7Content = jQuery('.estimates.estimates-form textarea[name=chat-bot]').val();
    if(skipQuestion == true || chatAnswer.trim() != '') {
        if(skipQuestion == false) {
            // Skip introduction question
            if(currentQuestionNo > 0) {
                // Save question and answer to CF7
                chatBotQuestions[currentQuestionNo] = '.boldstart.'+chatBotQuestions[currentQuestionNo]+'.boldend.';
                var chatQuestion = chatBotQuestions[currentQuestionNo].replace(/(<([^>]+)>)/gi, "");
                var updatedChatBotContent = chatBotCF7Content+chatQuestion+chatAnswer+"\n";
            }
            // Show answer in chat
            jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header .chat-conversation').last().append('<div class="chat-message answer"><div class="message">'+nl2br(chatAnswer)+'</div></div>');
            jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header .chat-conversation .chat-message').last().animate({ 'opacity':'1' }, 300);
            // Scroll to last message
            jQuery(".estimates.estimates-chat-bot .chat-bot .chat-bot-header").animate({ scrollTop: jQuery(".estimates.estimates-chat-bot .chat-bot .chat-bot-header").prop("scrollHeight")}, 600);
        }
        // If there are more questions
        var nextQuestionNo = currentQuestionNo + 1;
        if(nextQuestionNo < chatBotQuestions.length) {
            // Save next question no.
            jQuery('.estimates.estimates-chat-bot .chat-bot').data('question-no',nextQuestionNo);
            // Show next question in chat
            jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header').append('<div class="chat-conversation"><div class="chat-message question"><div class="message">'+chatBotQuestions[nextQuestionNo]+'</div></div></div>');
            jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header .chat-conversation .chat-message').last().stop().delay(chatBotAnimationDelay).animate({ 'opacity':'1' }, 300);
            // Scroll to the bottom of the chat
            scrollToElement('section.section-chat-bot .chat-bot .chat-bot-header');
        } else {
            updatedChatBotContent = '.newline.OPTIONAL ANSWERS.newline..newline.'+updatedChatBotContent;
            // Disable textarea
            jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').prop('disabled', true);
            jQuery('.chatbot-skip-question').remove();
            scrollToElement('bottom');
        }
        if(skipQuestion == false) {
            // Save chat bot CF7 content
            jQuery('.estimates.estimates-form textarea[name=chat-bot]').val(updatedChatBotContent);
        }
    }
    // Empty textarea
    jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').val('');
}

// Chat-bot - Show first chat question
function startChatBotConversation() {
    if(typeof jQuery('.estimates.estimates-chat-bot .chat-bot').attr('data-question-no') === 'undefined') {
        jQuery('.estimates.estimates-chat-bot .chat-bot').attr('data-question-no',0);
        jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header').append('<div class="chat-conversation"><div class="chat-message question"><div class="message">'+chatBotQuestions[0]+'</div></div></div>');
        jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-header .chat-conversation .chat-message').last().stop().delay(chatBotAnimationDelay*2).animate({ 'opacity':'1' }, 300);
        jQuery('.estimates.estimates-chat-bot .chat-bot .chat-bot-footer textarea').prop('disabled', false);
    }
}

// Check field
function checkField(field, noHighlight=false) {
    var fieldValue = field.val();
    var fieldType = field.prop('type');
    if(noHighlight == false) {
        field.parents('.col').find('.field-error').remove();
    }
    if(fieldValue == '') {
        if(noHighlight == false) {
            field.parents('.col').children('.subtitle').append('<span class="field-error">Field is required</span>');
        }
        return 0;
    } else if(fieldValue != '' && fieldType == 'email' && !isEmail(fieldValue)) {
        if(noHighlight == false) {
            field.parents('.col').children('.subtitle').append('<span class="field-error">Email is invalid</span>');
        }
        return 0;
    } else if(fieldValue != '' && fieldType == 'tel' && !isPhone(fieldValue)) {
        if(noHighlight == false) {
            field.parents('.col').children('.subtitle').append('<span class="field-error">Phone is invalid</span>');
        }
        return 0;
    }
    return 1;
}

// Check form
function checkForm(form, noHighlight=false) {
    var emptyFields = 0;
    jQuery(form+" .form input").not('input[type=submit], input[type=radio]').each(function() {
        if(checkField(jQuery(this), noHighlight) == 0) {
            emptyFields++;
        }
    });
    return emptyFields;
}

// Check if email is valid
function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

// Check if phone is valid
function isPhone(phone) {
    var regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return regex.test(phone);
}

// Jquery version of PHP nl2br
function nl2br(str, is_xhtml) {   
    var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';    
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1'+ breakTag +'$2');
}

// Get parameter from URL
function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};